<template>
  <b-container fluid>
    <b-row no-gutters>
      <b-col cols=2>
        <b-list-group>
          <b-list-group-item v-for="c in currencies.sort()"
                             v-bind:active="selected == c"
                             v-on:click="set_currency(c)"
                             class="trust_line_currency"
                             v-bind:key="c">
          {{c}}
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col>
        <b-list-group v-if="selected != ''">
          <b-list-group-item
            v-for="tl in trust_lines_for(selected)"
            v-bind:key="tl['account']"
            v-if="parseFloat(tl['balance']) != 0">
            <TrustLineSummary v-bind:trust_line="tl" />
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-container>

  <!-- TODO: multi-page trust lines, like txs and ledger objs -->
</template>

<script>
import TrustLineSummary from '../TrustLineSummary'

export default {
  name: 'AccountDetailsMeta',

  components : {
    TrustLineSummary
  },

  props : {
    id : String,
    trust_lines : Array,
  },

  data : function(){
    return {selected : ''};
  },

  computed : {
    currencies : function(){
      return Array.from(new Set(this.trust_lines.map(function(tl){ return tl.currency; })));
    }
  },

  methods :{
    set_currency : function(c){
      if(this.selected == c)
        this.selected = '';
      else
        this.selected = c;
    },

    trust_lines_for : function(c){
      return this.trust_lines.filter(function(tl){ return tl.currency == c; });
    }
  }
}
</script>

<style scoped>
.trust_line_currency{
  cursor: pointer;
}
</style>
